'use client';

import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { MAX_SELECTION_DURATION, MIN_SELECTION_DURATION } from './constants';

const MIN_WIDTH_FOR_FULL_LABEL = 120;
const MIN_WIDTH_FOR_SHORT_LABEL = 60;

interface DurationLabelProps {
    duration: number;
    /** Width of selection in pixels - used to determine label format */
    selectionWidth?: number;
    className?: string;
}

export function DurationLabel({
    duration,
    selectionWidth = MIN_WIDTH_FOR_FULL_LABEL,
    className = '',
}: DurationLabelProps): JSX.Element | null {
    if (duration < MIN_SELECTION_DURATION) return null;
    if (selectionWidth < MIN_WIDTH_FOR_SHORT_LABEL) return null;

    const formattedDuration = `${duration.toFixed(1)}s`;
    const showMaxSuffix = selectionWidth >= MIN_WIDTH_FOR_FULL_LABEL;

    return (
        <div
            className={twMerge(
                'absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2',
                'px-1 py-px rounded-xs text-xs font-normal',
                'bg-gray-950/70 text-white',
                'pointer-events-none select-none z-10',
                'transition-all duration-150',
                'leading-4 whitespace-nowrap',
                className,
            )}
            data-testid="duration-label"
        >
            {formattedDuration}
            {showMaxSuffix ? ` • ${MAX_SELECTION_DURATION}s max` : ''}
        </div>
    );
}
